import common from "../../common";
import QuestionModel from "../../maths/QuestionModel";
import QuestionViewStatementAlgebra from "./QuestionViewStatementAlgebra";

export default class QuestionViewStatementAlgebraPair extends QuestionViewStatementAlgebra {
    constructor(question) {
        super(question);
    }

    getHeaderText() {
        const templates = P3.assets.json("templates").templates;
        const split = this._question.template.split("/");

        let text = P3.utils.selectRandom(P3.utils.objectToArray(templates[split[0]][split[1]])).text;

        const data = P3.assets.json("templates");
        const words = data.words;

        const locations = this.generateWords(text, words.specific_locations, /\[SPECIFIC_LOCATION([0-9])?]/g);
        for (const i in locations) {
            if (locations.hasOwnProperty(i)) {
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), locations[i]);
            }
        }
        console.log(locations);

        let result = text.match(/\[VAR([0-9])?]/g);
        if (result) {
            return text.replace(result[0], this._question.answer.unknownCharacter);
        }

        return text;
    }

    createStatement(spacing = 40) {
        let width = 0;

        this._footer.statementA = new PIXI.Container();
        this._footer.addChild(this._footer.statementA);

        this._footer.statementB = new PIXI.Container();
        this._footer.addChild(this._footer.statementB);

        const operands = this._question.operands;

        const statementA = this._question.values.slice(0, 3);
        const statementB = this._question.values.slice(3, this._question.values.length);

        let j = 0;
        //build statement A
        for (let i = 0; i < statementA.length; ++i) {
            const value = statementA[i];

            const label = this.createLabel(value.toString(false));
            label.position.set(width, 0);
            this._footer.statementA.addChild(label);

            if (i < statementA.length - 1) {
                width += label.width + spacing;
            }

            // add operand
            if (j < 2) {
                const labelOp = this.createLabel(operands[j++]);
                labelOp.position.set(width, 0);
                this._footer.statementA.addChild(labelOp);
                i < this._question.values.length - 1 && (width += labelOp.width + spacing);
            }
        }

        // center statement
        this._footer.statementA.pivot.x = width * 0.5;
        width = 0;

        //build statement A
        for (let i = 0; i < statementB.length; ++i) {
            const value = statementB[i];

            const label = this.createLabel(value.toString(false));
            label.position.set(width, 50);
            this._footer.statementB.addChild(label);

            if (i < statementB.length - 1) {
                width += label.width + spacing;
            }

            // add operand
            const labelOp = this.createLabel(operands[j++]);
            labelOp.position.set(width, 50);
            this._footer.statementB.addChild(labelOp);

            i < this._question.values.length - 1 && (width += labelOp.width + spacing);
        }

        this._inputField.position.set(0, -100);
        this._footer.addChild(this._inputField);

        // center statement
        this._footer.statementB.pivot.x = width * 0.5;

        this._footer.statementA.y -= 30;
        this._footer.statementB.y -= 30;

        this._footer.pivot.y = -50;
    }

    filterTemplate(x) {
        return x.allow_q_mark === this._question.hasQuestionMark;
    }
}